
import Menu from '@/components/menu/menu.vue'
import { ElForm } from 'element-ui/types/form'
import { getHotelList } from '@/api/hotel'
import { getFinancial, postFinancial, putFinancial, deleteFinancial } from '@/api/ota'

import Vue from 'vue'
export default Vue.extend({
	components: {
		Menu,
	},
	data() {
		// 验证电话号码
		var validatePhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入电话号码'))
			}
			// 手机号正则（简单版）
			const phoneReg = /^1[3-9]\d{9}$/
			// 固话正则（带区号）
			const telReg = /^(0\d{2,3}-?)?[1-9]\d{6,7}$/

			if (phoneReg.test(value) || telReg.test(value)) {
				callback()
			} else {
				callback(new Error('请输入正确的电话号码'))
			}
		}

		// 验证银行账号
		var validateBankAccount = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入银行账号'))
			}
			// 简单校验：15-30位数字（实际应根据银行规则调整）
			const reg = /^\d{15,30}$/
			if (reg.test(value)) {
				callback()
			} else {
				callback(new Error('请输入15-30位数字的银行账号'))
			}
		}
		return {
			editInformationDialog: false,
			page: 1,
			limit: 10,
			total: 0,
			hotels: [] as any, // 酒店选项
			searchForm: {
				hotel_id: '',
			},
			editHotelDialog: false,
			submit_form: {
				id: '',
				hotel_id: '',
				contact: '',
				mobile: '',
				email: '',
				bank_name: '',
				bank: '',
				bank_card: '',
			},
			submit_form_rules: {
				hotel_id: [{ required: true, message: '请选择酒店', trigger: 'change' }],
				mobile: [
					{ required: true, message: '请输入电话', trigger: 'blur' },
					{ validator: validatePhone, trigger: 'blur' },
				],
				contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
				email: [
					{
						validator: (rule, value, callback) => {
							if (!(this as any).validateEmail(value)) {
								callback(new Error('请输入有效的邮箱地址'))
							} else {
								callback()
							}
						},
						trigger: 'blur',
					},
				],
				bank_name: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
				bank: [
					{ required: true, message: '请输入开户行', trigger: 'blur' },
					{ min: 4, max: 50, message: '长度在 4 到 50 个字符', trigger: 'blur' },
				],
				bank_card: [
					{ required: true, message: '请输入银行账号', trigger: 'blur' },
					{ validator: validateBankAccount, trigger: 'blur' },
				],
			},
			hotel_submit_form_title: '',
			room_type_form: {
				id: undefined as string | undefined,
				sale_type: '',
				pms_room_code: '',
				sale_room_name: '',
				sale_room_code: '',
				sale_info: [
					{
						sale_room_name: '',
						sale_room_code: '',
						sale_type: '',
					},
				],
			},
			editRoomDialog: false,
			orderStauts: '1',
			table_data: [],
			table_state: {
				loading: false,
			},
			diaTitle: '新增财务信息',
			src_channel: '携程',
			old_ding_secret: '',
			old_ding_webhook: '',
		}
	},
	created() {
		getHotelList().then((res) => {
			if (res.code == 0) {
				// 超级管理员/ota管理员有全部权限
				if (this.$store.state.admin.info.id == 1 || this.$store.state.admin.info.role_id == 19) {
					this.hotels = [{ id: 0, name: '全部' }].concat(res.data.rows)
				} else {
					this.hotels = res.data.rows
				}
				// this.searchForm.pms_hotel_code = this.hotels[0].miccode
				// this.searchForm.pms_hotel_id = this.hotels[0].id
				this.getFinancialList()
			}
		})
	},
	methods: {
		// 邮箱验证
		validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			return re.test(email)
		},
		// 打开新增财务信息框
		addInformation() {
			this.diaTitle = '新增财务信息'
			this.editInformationDialog = true
			;(this.$refs['info_form'] as ElForm).clearValidate()
		},
		// 获取财务信息维护列表
		getFinancialList() {
			this.table_state.loading = true
			getFinancial({
				hotel_id: this.searchForm.hotel_id,
				page: this.page,
				limit: this.limit,
			})
				.then((res) => {
					if (res.code == 0) {
						let data = res.data
						this.total = res.count
						this.table_data = data.map((item) => {
							let { hotel_id } = item
							let hotel = this.hotels.find((item2) => {
								return item2.id == hotel_id
							})
							return {
								...item,
								hotel_name: hotel ? hotel.name : '',
							}
						})
					}
				})
				.finally(() => {
					this.table_state.loading = false
				})
		},
		changePages(data) {
			this.page = data
			this.getFinancialList()
		},
		changeLimit(data) {
			this.page = 1
			this.limit = data
			this.getFinancialList()
		},
		infoEdit(row) {
			this.submit_form = row
			this.diaTitle = '编辑财务信息'
			this.editInformationDialog = true
		},
		search(e) {
			this.getFinancialList()
		},
		// 关闭dia重置表单
		closeHotelDialog() {
			this.submit_form = {
				id: '',
				hotel_id: '',
				contact: '',
				email: '',
				bank_name: '',
				bank: '',
				mobile: '',
				bank_card: '',
			}
			;(this.$refs['info_form'] as ElForm).clearValidate()
		},
		closeRoomDialog() {
			this.room_type_form = {
				id: '',
				sale_type: '',
				pms_room_code: '',
				sale_room_name: '',
				sale_room_code: '',
				sale_info: [
					{
						sale_room_name: '',
						sale_room_code: '',
						sale_type: '',
					},
				],
			}
			;(this.$refs['room_form'] as ElForm).clearValidate()
		},
		addRoomsListItem() {
			let item = {
				sale_room_name: '',
				sale_room_code: '',
				sale_type: '',
			}
			this.room_type_form.sale_info.push(item)
		},
		removeRoomsListItem(index: number) {
			this.room_type_form.sale_info.splice(index, 1)
		},
		infoDelete(row: { id: number }) {
			this.$confirm('确定要删除此条财务信息数据吗？', '', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					deleteFinancial({
						id: row.id,
					}).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: res.msg,
							})
						}
						this.getFinancialList()
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		resetForm(formName: string) {
			this.$nextTick(() => {
				;(this.$refs[formName] as ElForm).resetFields()
			})
		},
		submitForm(formName: string) {
			;(this.$refs[formName] as ElForm).validate((valid) => {
				if (valid) {
					if (this.submit_form.id === '') {
						console.log('新增')
						postFinancial({
							...this.submit_form,
						}).then((res) => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: res.msg,
								})
								this.editInformationDialog = false
								this.getFinancialList()
							}
						})
					} else {
						console.log('编辑')
						console.log(this.submit_form)
						putFinancial({
							...this.submit_form,
						}).then((res) => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: res.msg,
								})
								this.editInformationDialog = false
								this.getFinancialList()
							}
						})
					}
				} else {
					return false
				}
			})
		},
	},
})
